import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import { showHideRecaptchaBadge } from 'utils/recaptchaToken'
import modalStyles from 'styles/modal.module.scss'

const Modal = ({ children }) => {
  const { activeForm } = useContext(ModalContext)
  showHideRecaptchaBadge(activeForm !== 'register')
  return activeForm ? (
    <div className={modalStyles.wrapper}>{children}</div>
  ) : null
}

export default Modal
